module.exports = __webpack_public_path__ + "static/fulllogo-def36dbaedb9bf34638f7ab86bee10f1.svg";